import React, { useEffect, useState } from 'react';

const WinnerCelebration = ({ winner, season, totalWeeks, onClose }) => {
  const [confettiPieces, setConfettiPieces] = useState([]);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Generate confetti pieces
    const pieces = [];
    for (let i = 0; i < 100; i++) {
      pieces.push({
        id: i,
        left: Math.random() * 100,
        animationDelay: Math.random() * 3,
        animationDuration: 3 + Math.random() * 2,
        color: ['#FFD700', '#FFA500', '#FF69B4', '#87CEEB', '#98FB98', '#DDA0DD'][Math.floor(Math.random() * 6)],
        rotation: Math.random() * 360,
      });
    }
    setConfettiPieces(pieces);

    // Show content with delay for dramatic effect
    setTimeout(() => setShowContent(true), 300);
  }, []);

  const winPercentage = winner.total_picks > 0 
    ? ((winner.correct_picks / winner.total_picks) * 100).toFixed(1)
    : 0;

  return (
    <div className="celebration-overlay">
      {/* Confetti */}
      <div className="confetti-container">
        {confettiPieces.map((piece) => (
          <div
            key={piece.id}
            className="confetti-piece"
            style={{
              left: `${piece.left}%`,
              animationDelay: `${piece.animationDelay}s`,
              animationDuration: `${piece.animationDuration}s`,
              backgroundColor: piece.color,
              transform: `rotate(${piece.rotation}deg)`,
            }}
          />
        ))}
      </div>

      {/* Celebration Content */}
      <div className={`celebration-content ${showContent ? 'show' : ''}`}>
        <div className="celebration-header">
          <div className="trophy-icon">🏆</div>
          <h1 className="celebration-title">CHAMPION!</h1>
        </div>

        <div className="winner-info">
          <div className="winner-name-container">
            <div className="sparkle sparkle-left">✨</div>
            <h2 className="winner-name">{winner.name}</h2>
            <div className="sparkle sparkle-right">✨</div>
          </div>
          
          <div className="season-badge">
            {season} Season Champion
          </div>

          <div className="winner-stats">
            <div className="stat-card">
              <div className="stat-value">{winner.correct_picks}-{winner.total_picks - winner.correct_picks}</div>
              <div className="stat-label">Final Record</div>
            </div>
            <div className="stat-card highlight">
              <div className="stat-value">{winPercentage}%</div>
              <div className="stat-label">Win Percentage</div>
            </div>
            <div className="stat-card">
              <div className="stat-value">{totalWeeks}</div>
              <div className="stat-label">Weeks Played</div>
            </div>
          </div>

          <div className="celebration-message">
            <p className="message-text">
              🎉 Congratulations on an incredible season! 🎉
            </p>
            <p className="message-subtext">
              You've proven yourself to be the ultimate college football predictor!
            </p>
          </div>

          <div className="fireworks-container">
            <div className="firework firework-1">💥</div>
            <div className="firework firework-2">🎆</div>
            <div className="firework firework-3">✨</div>
            <div className="firework firework-4">🌟</div>
          </div>
        </div>

        <button className="celebration-close-btn" onClick={onClose}>
          Continue to New Season
          <span className="arrow-icon">→</span>
        </button>
      </div>
    </div>
  );
};

export default WinnerCelebration;
